import React, { useState } from 'react';
import { Wallet, ShieldCheck, TrendingUp } from 'lucide-react';

const LSGFramework = () => {
  const [activeSection, setActiveSection] = useState(null);

  const sections = [
    {
      id: 'liquidity',
      icon: Wallet,
      title: "Liquidity",
      description: "For immediate cash flow needs and contingencies",
      details: [
        "Emergency funds",
        "Short-term expenses",
        "Upcoming financial commitments",
        "Easily accessible cash reserves"
      ]
    },
    {
      id: 'safety',
      icon: ShieldCheck,
      title: "Safety",
      description: "To protect capital with low-volatility assets",
      details: [
        "Capital preservation instruments",
        "Fixed income securities",
        "Low-risk investments",
        "Inflation protection"
      ]
    },
    {
      id: 'growth',
      icon: TrendingUp,
      title: "Growth",
      description: "To compound wealth over time through high-quality equity investments",
      details: [
        "Long-term wealth creation",
        "Equity market participation",
        "Diversified growth assets",
        "Strategic allocation to outperforming sectors"
      ]
    }
  ];

  return (
    <div className="bg-white pt-12">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">What Is the LSG Framework?</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            <strong>LSG</strong> stands for:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {sections.map((section) => (
            <div
              key={section.id}
              className={`bg-white rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl ${activeSection === section.id ? 'ring-2 ring-[#1C52A0]' : ''}`}
              onClick={() => setActiveSection(activeSection === section.id ? null : section.id)}
            >
              <div className="p-6">
                <div className="w-12 h-12 bg-[#E8EEF6] rounded-lg flex items-center justify-center">
                  <section.icon className="h-6 w-6 text-[#1C52A0]" />
                </div>
                <h3 className="mt-4 text-xl font-semibold text-[#113262]">{section.title}</h3>
                <p className="mt-2 text-gray-600">{section.description}</p>

                <div className={`mt-4 transition-all duration-300 ${activeSection === section.id ? 'max-h-48' : 'max-h-0 overflow-hidden'}`}>
                  <ul className="space-y-2">
                    {section.details.map((detail, index) => (
                      <li key={index} className="flex items-center text-gray-600">
                        <div className="w-1.5 h-1.5 bg-[#F49611] rounded-full mr-2"></div>
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-4 p-2 bg-[#E8EEF6] rounded-lg text-center">
          <p className="text-sm text-[#113262]">
            The LSG framework is not a fixed formula. It adapts to your life stage, income profile and financial goals. It gives structure to our <strong className="text-[#1C52A0]">portfolio management services (PMS)</strong> while ensuring that you remain invested with confidence—no matter what markets are doing.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LSGFramework;